import React from 'react';
import { Row, Col, Button, FormControl } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FormattedMessage } from 'react-intl';

const CreateItemForm = ({heading, setFunc, placeholder, link}) => {
  return (
    <div className="add-event-container">
      <Row className="no-gutters align-items-center">
        <Col xs={4}>
          <h6><FormattedMessage id={heading} /></h6>
        </Col>
        <Col>
          <FormControl onChange={(e) => {
            setFunc(e.target.value)
          }} placeholder={placeholder} type="text" />
        </Col>
        <Col xs={2}>
          <Link className="d-flex" to={link}>
            <Button>
              <img src="/icons/plus-big.png" alt="plus" />
            </Button>
          </Link>
        </Col>
      </Row>
    </div>
  )
}

export default CreateItemForm;